__turbopack_context__.v({
  "accordionSlideOverwrite": "registrationComplete-module-scss-module__LfTjzW__accordionSlideOverwrite",
  "fadeIn": "registrationComplete-module-scss-module__LfTjzW__fadeIn",
  "fadeOut": "registrationComplete-module-scss-module__LfTjzW__fadeOut",
  "image": "registrationComplete-module-scss-module__LfTjzW__image",
  "registrationComplete": "registrationComplete-module-scss-module__LfTjzW__registrationComplete",
  "scaleIn": "registrationComplete-module-scss-module__LfTjzW__scaleIn",
  "scaleOut": "registrationComplete-module-scss-module__LfTjzW__scaleOut",
  "text": "registrationComplete-module-scss-module__LfTjzW__text",
  "zoomIn": "registrationComplete-module-scss-module__LfTjzW__zoomIn",
  "zoomOut": "registrationComplete-module-scss-module__LfTjzW__zoomOut",
});
